import { isTemplateReference, stripTemplateReferencePrefix } from './attributes/template/common';
import type { GradientPoint } from './GradientPoint';

export type GradientFillGraphic = {
    fillType: string;
    gradientStartPoint: GradientPoint;
    gradientEndPoint: GradientPoint;
};

/** Reads a colour attribute, stripping the `themeRef_` prefix when it holds a template reference. */
const resolveColorValue = (value: unknown): number => {
    if (isTemplateReference(value)) {
        return stripTemplateReferencePrefix(value) as unknown as number;
    }
    return value as number;
};

/**
 * Adjusts a color-graphics map for a single graphic's fill type. A solid fill keeps its existing
 * fill colour entry; a linear (gradient) fill replaces it with the two gradient stop colours
 * (`gradientStartPoint.color` / `gradientEndPoint.color`). Mutates `colorMap` in place.
 *
 * @param solidFillKey the attribute name of the solid fill colour for this graphic shape — `fill`
 * for text graphics, `fillColor` for scene-design graphics.
 */
export const applyGradientFillColors = (
    colorMap: Record<string, number>,
    graphic: GradientFillGraphic,
    prefix: string,
    solidFillKey: string,
): void => {
    if (graphic.fillType !== 'linear') {
        return;
    }
    delete colorMap[`${prefix}.${solidFillKey}`];
    colorMap[`${prefix}.gradientStartPoint.color`] = resolveColorValue(
        graphic.gradientStartPoint.color,
    );
    colorMap[`${prefix}.gradientEndPoint.color`] = resolveColorValue(
        graphic.gradientEndPoint.color,
    );
};
